export default __webpack_public_path__ + "static/54-f9a155ee03097507d8d306034ec397ae.png";